<template>
  <d-navbar-nav class="border-left flex-row">
    <!-- <li class="nav-item border-right dropdown notifications">
      <a class="nav-link nav-link-icon text-center" v-d-toggle.notifications>
        <div class="nav-link-icon__wrapper">
          <i class="material-icons">&#xE7F4;</i>
          <d-badge pill theme="danger">2</d-badge>
        </div>
      </a>
      <d-collapse id="notifications" class="dropdown-menu dropdown-menu-small">
        <d-dropdown-item>
          <div class="notification__icon-wrapper">
            <div class="notification__icon">
              <i class="material-icons">&#xE6E1;</i>
            </div>
          </div>
          <div class="notification__content">
            <span class="notification__category">Analytics</span>
            <p>Your website’s active users count increased by <span class="text-success text-semibold">28%</span> in the last week. Great job!</p>
          </div>
        </d-dropdown-item>
        <d-dropdown-item href="#">
          <div class="notification__icon-wrapper">
            <div class="notification__icon">
              <i class="material-icons">&#xE8D1;</i>
            </div>
          </div>
          <div class="notification__content">
            <span class="notification__category">Sales</span>
            <p>Last week your store’s sales count decreased by <span class="text-danger text-semibold">5.52%</span>. It could have been worse!</p>
          </div>
        </d-dropdown-item>
        <d-dropdown-item class="notification__all text-center">View all Notifications</d-dropdown-item>
      </d-collapse>
    </li> -->
    <li class="nav-item dropdown">
      <a class="nav-link dropdown-toggle text-nowrap px-3" v-d-toggle.user-actions>
        <div style="padding-top: 15px;font-size: 12px; display:inline-block;">
          <span class="d-md-inline-block">{{this.name}}</span>
        </div>
      </a>
      <d-collapse id="user-actions" class="dropdown-menu dropdown-menu-small">
        <d-link to="/magazine" style="text-decoration: none;">
          <d-dropdown-item >
            <i class="material-icons">book</i> Artigos
          </d-dropdown-item>
        </d-link>
        <d-link to="/profile" style="text-decoration: none;">
          <d-dropdown-item >
            <i class="material-icons">&#xE7FD;</i> Perfil
          </d-dropdown-item>
        </d-link>
        <a @click="goToSite()" href="#" style="text-decoration: none;">
          <d-dropdown-item >
            <i class="material-icons">&#xE879;</i> Voltar para o site
          </d-dropdown-item>
        </a>
        <d-dropdown-divider />
        <a @click="logout()" href="#" style="text-decoration: none;">
          <d-dropdown-item class="text-danger">
            <i class="material-icons text-danger">&#xE879;</i> Logout
          </d-dropdown-item>
        </a>
      </d-collapse>
    </li>
  </d-navbar-nav>
</template>

<style>
  .nav-link:hover {
    cursor: pointer;
  }
</style>
<script>
import {setCookie, getCookie} from '../../../utils'
export default {
  name: 'navbar-nav',
  data() {
    return {
      name: getCookie('name-client'),
    };
  },
  methods: {
    logout() {
      setCookie('email-client', '', 2);
      setCookie('name-client', '', 2);
      setCookie('token-client', '', 2);
      setCookie('id-client', '', 2);
      document.location.href="./login"
      // this.$eventHub.$emit('toggle-sidebar');
    },
    goToSite() {
      document.location.href="https://fisiologiadotreinamento.com/";
    }
  },
};
</script>
